<template>
  <div class="flex h-[calc(100vh-7rem)] min-h-[620px] overflow-hidden rounded-md border bg-background">
    <ConversationListPanel />

    <section class="hidden min-w-0 flex-1 items-center justify-center text-sm text-muted-foreground md:flex">
      Select a conversation.
    </section>
  </div>
</template>

<script setup>
import ConversationListPanel from '../components/conversations/ConversationListPanel.vue'
</script>
